import { getQueryStringParameter } from 'owa-querystring';
import { postSignal } from './ariaUtils';
import { createBootReliabilityAriaEvent } from './createBootReliabilityAriaEvent';
import type StartConfig from './interfaces/StartConfig';
import { resolvePendingDatapoints, addPASKeyMetric } from 'owa-performance';
import { setPltValues } from 'owa-plt-data';
import { markPLTFinished } from 'owa-config';

const performanceMarkQueryStringParam = 'pm';
const perfMarkName = 'plt';

export function onBootComplete(config: StartConfig, start?: number): void {
    if (config.skipStartupSignal) {
        return;
    }
    const bootCompleted = Math.floor(window.performance.now());
    const plt = config.wasUserPrompted ? undefined : bootCompleted;
    setPltValues(plt, bootCompleted);
    const timings = {
        start,
        plt,
        upt: config.userPromptTime,
    };

    if (timings?.plt && timings?.start !== undefined) {
        const parameter = getQueryStringParameter(performanceMarkQueryStringParam);
        if (
            parameter != undefined &&
            (parameter === '' || parameter.toLowerCase().indexOf(perfMarkName) !== -1)
        ) {
            const perfStart = timings.start + (window.performance.now() - Date.now());
            performance.measure(perfMarkName, { start: perfStart, end: timings.plt });
        }

        addPASKeyMetric(perfMarkName, timings.plt);
    }

    resolvePendingDatapoints();

    postSignal(createBootReliabilityAriaEvent('ok', undefined, timings));

    markPLTFinished();
}
